module.exports = __webpack_public_path__ + "assets/img/tianJia.042650a5.svg";